import { useSelector } from "react-redux";
import Page from "./Page";
import RepCalendar from "../ui/RepCalendar";

import useBrowser from "../../hooks/useBrowser";
import useLocalization from "../../hooks/useLocalization";
import { Box } from "@mui/material";

const Dashboard = () => {
  const { windowHeight, windowWidth } = useBrowser();
  const { getTitle } = useLocalization();

  const userId = useSelector((state) => state.authentication.userId);

  return (
    <Page title={getTitle("schedule")}>
      <Box sx={{ height: "100%" }}>
        <RepCalendar repId={userId} />
      </Box>
    </Page>
  );
};

export default Dashboard;
